import { createPortal } from "react-dom";
import { createRoot, type Root } from "react-dom/client";
import LoadingBars from "../Loading/LoadingBars";

const LoadingMaskComponent = () => {
  return createPortal(
    <div id="test-loading" className="modal modal-open flex-center z-[998]">
      <LoadingBars />
    </div>,
    document.body,
  );
};

type LoadingMask = {
  root: Root | null;
  rendered: boolean;
  open: () => void;
  close: () => void;
};

export const LoadingMask: LoadingMask = {
  root: null,
  rendered: false,
  open() {
    if (!this.root) {
      const container = document.createDocumentFragment();
      this.root = createRoot(container);
    }

    if (!this.rendered) {
      this.root.render(<LoadingMaskComponent />);
      this.rendered = true;
    }
  },
  close() {
    this.root?.unmount();
    this.root = null;
    this.rendered = false;
  },
};
